export const address = "https://poosdapi.torrentofshame.com"
